// src/services/jobServices.ts
import axios from "../lib/axios";

// Create a new job
export const createJob = async (data) => {
  try {
    const response = await axios.post("/jobs", data);
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Failed to create job");
  }
};

// Get all jobs
export const getAllJobs = async ({
  lastId,
  limit = 10,
  status = null,
} = {}) => {
  try {
    const params = new URLSearchParams();

    if (lastId) params.append("lastId", lastId);
    if (limit) params.append("limit", limit.toString());
    if (status) params.append("status", status);

    const response = await axios.get(`/jobs?${params.toString()}`);
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Failed to fetch jobs");
  }
};

// Update job status by ID
export const updateJobStatus = async (id, data) => {
  try {
    const response = await axios.patch(`/jobs/${id}`, data);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to update job status"
    );
  }
};

// Delete job by ID
export const deleteJob = async (id) => {
  try {
    const response = await axios.delete(`/jobs/${id}`);
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Failed to delete job");
  }
};

// Update job status by ID
export const updateJobApplicationStatus = async (id, data) => {
  try {
    const response = await axios.patch(`/jobs/job-application/${id}`, data);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to update job status"
    );
  }
};

// Delete job by ID
export const deleteJobApplication = async (id) => {
  try {
    const response = await axios.delete(`/jobs/job-application/${id}`);
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Failed to delete job");
  }
};

export const createJobApplication = async (data) => {
  try {
    const response = await axios.post("/jobs/create", data);
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Failed to create job");
  }
};

export const getAllJobsApplication = async ({
  lastId,
  limit = 10,
  jobId,
} = {}) => {
  try {
    const params = new URLSearchParams();

    if (lastId) params.append("lastId", lastId);
    if (limit) params.append("limit", limit.toString());
    if (jobId) params.append("jobId", jobId);

    const response = await axios.get(`/jobs/all?${params.toString()}`);
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Failed to fetch jobs");
  }
};

export const updateJob = async (id, data) => {
  try {
    const response = await axios.put(`/jobs/update/${id}`, data);
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Failed to create job");
  }
};

export const getJob = async (id) => {
  try {
    const response = await axios.get(`/jobs/${id}`);
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Failed to create job");
  }
};
